module.exports = __webpack_public_path__ + "static/group-80c6520865624136b4feeaf23b4556c1.jpg";